// PC（ListFilter）与移动端（MobileFilterDrawer）共用的筛选项交互逻辑
export default {
  data() {
    return {
      // 系列搜索关键词
      seriesSearchKw: ''
    };
  },
  computed: {
    // 系列列表：根据关键词做前端模糊搜索（不区分大小写）
    filteredSeriesItems() {
      const kw = (this.seriesSearchKw || '').trim().toLowerCase();
      const items = this.filterOpts.series.items || [];
      if (!kw) return items;
      return items.filter(item => String(item.name || '').toLowerCase().includes(kw));
    }
  },
  methods: {
    // 勾选/取消筛选项：更新 checked 并同步到路由 query（页面 watch $route 后统一刷新）
    toggleItem(opt, ref) {
      ref += '';
      // 选项处理
      let optionCache = this.filterOpts[opt];
      if (optionCache && optionCache.checked != undefined) {
        // 多选项处理
        if (Array.isArray(optionCache.checked)) {
          let optIdx = optionCache.checked.indexOf(ref);
          if (optIdx != -1) {
            optionCache.checked.splice(optIdx, 1);
          } else {
            optionCache.checked.push(ref);
          }
        } else {
          optionCache.checked = ref;
        }
        // 处理过滤条件的变动
        let newQuery;
        // 兼容 Array(多选) 和 String(单选价格)
        const hasChecked = Array.isArray(optionCache.checked)
          ? optionCache.checked.length
          : !!optionCache.checked;
        if (hasChecked) {
          newQuery = Object.assign({}, this.$route.query, { [opt]: optionCache.checked.toString() })
        } else {
          newQuery = Object.assign({}, this.$route.query);
          delete newQuery[opt];
        }
        // 筛选变化后回到第 1 页: 移除 page 参数, parseRouteQuery 缺省时 currPage 复位为 1
        delete newQuery.page;
        this.$router.push({
          path: this.$route.path,
          query: newQuery
        });
      } else {
        console.warn(`没有找到${opt}选项相关数据`);
      }
    }
  }
};
